import { gql } from '@apollo/client';

import { CustomMatchListColumn as CustomMatchListColumnsOperation_customMatchListColumns } from 'core/graphql';

export type CustomMatchListColumn =
  CustomMatchListColumnsOperation_customMatchListColumns;

export const CUSTOM_MATCH_LIST_COLUMNS_QUERY = gql`
  query CustomMatchListColumnsOperation {
    customMatchListColumns {
      id
      name
      fields
    }
    customMatchListColumnLimit
  }
`;

export interface ColumnLabels {
  [key: string]: string;
}

/**
 * What parts of a record can we match to?
 */
export const targetColumnOptions = [
  { value: 'Hostname', label: 'Hostname' },
  { value: 'FileHash', label: 'File Hash' },
  { value: 'Url', label: 'URL' },
  { value: 'Domain', label: 'Domain', new: true },
  { value: 'Username', label: 'Username', new: true },
  { value: 'Ip', label: 'IP Address', new: true },
  { value: 'Asn', label: 'IP ASN', new: true },
  { value: 'Isp', label: 'IP ISP', new: true },
  { value: 'Org', label: 'IP Organization', new: true },
  { value: 'SrcIp', label: 'Source IP Address' },
  { value: 'SrcAsn', label: 'Source IP ASN', new: true },
  { value: 'SrcIsp', label: 'Source IP ISP', new: true },
  { value: 'SrcOrg', label: 'Source IP Organization', new: true },
  { value: 'DstIp', label: 'Destination IP Address' },
  { value: 'DstAsn', label: 'Destination IP ASN', new: true },
  { value: 'DstIsp', label: 'Destination IP ISP', new: true },
  { value: 'DstOrg', label: 'Destination IP Organization', new: true },
];

export const targetColumnLabels: ColumnLabels = targetColumnOptions.reduce(
  (
    labels: { [k: string]: string },
    option: { value: string; label: string }
  ) => {
    labels[option.value] = option.label;
    return labels;
  },
  {}
);

export const getColumnLabels = (columns?: CustomMatchListColumn[]) =>
  columns
    ? columns.reduce(
        (idNameMap, column) => {
          idNameMap[column.id] = column.name;
          return idNameMap;
        },
        { ...targetColumnLabels }
      )
    : targetColumnLabels;
